// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"en-z","badgeLink":"fn-z","category":"gn-z"};